<template>
  <div class="st-header">
    <div class="st-header-content">
      <div class="st-header-left">
        <span v-if="homeAble" @click="home">
          <span>
            <i class="el-icon-s-home"></i>
          </span>
        </span>

        <span v-if="backAble" @click="back">
          <span>
            <i class="el-icon-arrow-left"></i>
          </span>
          <span class="st-header-back">返回</span>
        </span>
        <span class="st-header-close" v-if="closeAble" @click="back">关闭</span>
        <span>&emsp;</span>
      </div>
      <div class="st-header-center">{{ title }}</div>
      <div class="st-header-right">
        <slot name="header-right">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: () => {
        return '';
      }
    },
    backAble: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    closeAble: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    homeAble: {
      type: Boolean,
      default: () => {
        return false;
      }
    }

  },
  data() {
    return {
      
    };
  },
  watch: {},

  methods: {
    init() {},
    back() {
      this.$router.go(-1);
    },
    home() {
      this.$router.push('/');
    },
  },
  created() {
    this.init();
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.st-header {
  overflow: hidden;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;

  .st-header-content {
    width: 100%;
    position: fixed;
    z-index: 10;
    background-color: white;
  }

  .st-header-left {
    float: left;
    width: 25%;
    .el-icon-s-home,.el-icon-arrow-left {
      font-size: 24px;
      font-weight: bold;
      transform: translateY(4px);
    }
    .el-icon-s-home{
      margin-left: 15px;
    }
    .st-header-close {
      margin-left: 14px;
    }
  }

  .st-header-center {
    float: left;
    width: 50%;
    text-align: center;
  }

  .st-header-right {
    float: right;
    width: 20%;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
